import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Slot } from '@radix-ui/react-slot';
import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';
import { buttonVariants } from './button-variants';
function Button({ className, asChild = false, children, disabled, loading = false, size, variant, ...props }) {
    const Comp = asChild ? Slot : 'button';
    return (_jsx(Comp, { "aria-busy": loading || undefined, className: cn(buttonVariants({ className, size, variant })), "data-slot": "button", disabled: asChild ? undefined : (disabled ?? loading), ...props, children: loading && !asChild ? (_jsxs(_Fragment, { children: [_jsx(Loader2, { className: "animate-spin" }), children] })) : (children) }));
}
export { Button };
